export const PL = {
  TITLE: "Plan Doskonały",
  INTRO1:
    "Serwus! Pracuję nad projektem aplikacji, która zautomatyzuje montowanie filmów. Biorąć udział w Quizie i poprawnie identyfikując rodzaje kadrów ze znanych filmów pomagasz trenować model AI, który jest sercem aplikacji.",
  INTRO2:
    "Zanim zaczniesz rozgrywkę przejdź proszę do sekcji 'rozpocznij naukę'. Projekt jest częścią pracy inżynierskiej: Szymona Rucińskiego",
  LEARNHELLO: "słowem wstępu",
  BEGINQUIZ: "Rozpocznij zabawę",
  BEGINLEARNING: "Rozpocznij naukę",
  LEARNINTRO1DROPCAP: "C",
  LEARNINTRO1:
    "hciałbym zapoznać Cię z typami planów/kadrów filmowych. Twoja pomoc jest dla mnie bezcenna i bardzo chcę Ci za nią podziękować już na wstępie. W poniższych sekcjach zawarłem informacje jaki dane kadry mają wpływ na odbiór filmu oraz jak najszybciej je zidentyfikować. Mam nadzieję, że będziesz się przy tym dobrze bawił i dowiesz się więcej o elementach gramatyki języka filmowego.",
  LEARNINTRO2:
    "Quiz, który przyjdzie Ci rozwiązać składa się z 25 klatek filmowych. Do każdej z nich przyjdzie Ci dobrać odpowiedni typ planu. Nie będziesz mógł przejść do kolejnego pytania bez oddania odpowiedzi. Odpowiedzi są przesyłane na serwer po sklasyfikowaniu 100% ujęć i wyrażeniu zgody na publikację wyników. Skoro wstęp już mamy za sobą pora przejść do nauki!",
  LEARNINTRO3:
    "W mojej bazie danych udało mi się zgromadzić około 156 tysięcy zdjęc z 2504 filmów, które czekają na sklasyfikowanie.",
  LEARNEXTREMELONGSHOTDROPCAP: "S",
  LEARNEXTREMELONGSHOT1:
    "łuży do pokazania krajobrazu, szerokiej perspektywy miejsca akcji. To ogólny obraz topografii przestrzeni akcji. Ludzka postać jest niewielka. Ten plan używany jest do ogólnych opisów miejsca akcji oraz prezentacji pleneru ",
  LEARNEXTREMELONGSHOT2:
    "Pokazuje miejsce akcji w kategoriach geograficzno-urbanistycznych. Sylwetki osób widoczne, identyfikacja postaci niemożliwa, widoczny krajobraz, ukształtowanie terenu, rodzaj zabudowy itp.",
  LEARNLONGSHOTDROPCAP: "R",
  LEARNLONGSHOT1:
    "odzaj również szerokiego ujęcia pokazującego miejsce akcji, jednak nie dla pokazania samego krajobrazu, ale w odniesieniu do filmowanej postaci, zwykle widocznej jako sylwetka. Określa w ten sposób miejsce bohatera wobec otoczenia.",
  LEARNLONGSHOT2:
    "pokazuje miejsce akcji w skali architektonicznej, pojedynczy budynek, niewielkie, rozpoznawalne postaci, duże grupy ludzi. Wysokość sylwetki mniej więcej równa połowie wysokości kadru.",
  LEARNFULLSHOTDROPCAP: "J",
  LEARNFULLSHOT1:
    "est to plan w którym widzimy całą postać wypełniającą kadr, ale jesteśmy w stanie określić w jakim otoczeniu się znajduje. pokazuje postać lub grupę postaci w pełnej wysokości, z niewielkim marginesem pod stopami i nad głową. Łatwo identyfikuje się działania i gestykulacja postaci, mniej czytelna jest mimika.",
  LEARNFULLSHOT2:
    "Jego charakterystyczną checą jest to że przedstawia bohatera od stóp do głów. Aktor zawiera się prawie zawsze w całej długości kadru.",
  LEARNMEDIUMSHOTDROPCAP: "N",
  LEARNMEDIUMSHOT1:
    "a tego rodzaju planie widać postać ludzką od bioder w górę oraz otoczenie. Wykorzystywany jest przy scenach dialogowych, buduje relacje pomiędzy bohaterami. W westernach był wykorzystywany do ukazania pojedynków.",
  LEARNMEDIUMSHOT2:
    "Tak zwany plan Amerykański również jest wariantem planu średniego. Aktor w nim przedstawiony jest kadrowany od kolan w górę.",
  LEARNCLOSEUPDROPCAP: "P",
  LEARNCLOSEUP1:
    "okazuje postać od łokci w górę. Tzw. plan portretowy (Półzbliżenie). Postać może być również pokazana od piersi (ramion) w górę. Plan intymny, prezentujący mimikę i stan psychiczny postaci. (Zbliżenie)",
  LEARNCLOSEUP2:
    "Duże zbliżenie pokazuje twarz postaci, czasami obciętą od góry. Plan bardzo intymny, prezentujący niuanse gry psychologicznej, łzy, kierunek spojrzenia, mrugnięcie oka.",
  LEARNCLOSEUPCOMMENT1:
    "Przykład zbliżenia gdzie w kadrze mamy więcej niż jednego bohater. Kadrowanie od popiersia w górę.",
  LEARNCLOSEUPCOMMENT2:
    "Wyżej wymienione zbliżeni, półzbliżeni i duże zbliżenia powinieneś zaklasyfikować jako zbliżenie rozwiącując Quizz.",
  LEARNDETAILDROPCAP: "M",
  LEARNDETAIL1:
    "akro detal jest to najbliższy kadr filmowy, ukazanie wycinka rzeczywistości, który jest niedostrzegalny gołym okiem, na przykład drobne mechanizmy w zegarku lub wnętrze ludzkiego ciała.",
  // LEARNDETAILCOMMENT1: "Co prawda w tym karze widoczna jest twarz bohatera, ale widzimy ją w ogromnym zbliżeniu i niecałą dlatego klasyfikuję to ujęcie jak makrodetal.",
  LEARNDETAIL2:
    "Detal to niewielki fragment obiektu, np. część twarzy, oko. Czytelna faktura skóry, zmarszczki, rzęsy. Rozpoznawalna jest jednak większa całość, do której detal należy. W moim projekcie makro detal oraz detal można sklasyfikować do tej samej grupy.",
  PROGRESS: "Twój postęp: ",
  EXTREMELONGSHOT: "plan totalny ",
  LONGSHOT: "plan ogólny ",
  FULLSHOT: "plan pełny ",
  MEDIUMSHOT: "plan średni ",
  MEDIUMCLOSEUP: "półzbliżenie",
  CLOSEUP: "zbliżenie ",
  MACRODETAIL: "detal ",
  AMBIGUOUS:"niejasny",
  SUCCESSFULLYCOMPLETED: "Doskonale Ukończyłeś Quiz!✅",
  THANKSFORHELP: "Bardzo Ci dziękuję za pomoc!",
  YOUARETRAININGAI:
    "Grając w mój Quiz pomagasz trenować model sztucznej inteligencji na serwerze. Mam nadzieję, że wszystkie odpowiedzi zaznaczyłeś prawidłowo😊",
  WANTUPLOAD: "Czy chcesz przesłać swoje odpowiedzi?",
  YES: "TAK",
  NO: "NIE",
  HELPTOTRAINAI: "Pomóż mi wytrenować sztuczną inteligencję :)",
};
